/**
 * Shown when the branding says `ready:false` (account not charges-enabled, or the
 * account is past-due / restricted) OR when a charge comes back 409 NotReady (the
 * load↔submit race). Donor-first, reassuring copy — never a raw error, never a
 * dollar figure — so a committee paperwork lapse never loses a gift or leaks detail.
 */
export function DonationUnavailable({ committeeName }: { committeeName?: string }) {
  return (
    <div className="mx-auto max-w-md rounded-lg border border-border bg-muted/30 p-6 text-center space-y-3">
      <h1 className="text-lg font-semibold text-foreground">
        Donations are temporarily unavailable
      </h1>
      <p className="text-sm text-muted-foreground">
        {committeeName ? `${committeeName} ` : 'This campaign '}
        can&apos;t accept gifts online right now. Any gifts already received are
        safe — please check back shortly.
      </p>
    </div>
  );
}
